var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ToastContainer as RToastContainer } from 'react-toastify';
import { CheckCircle, InfoCircle, XClose } from '@untitled-ui/icons-react';
import { FeaturedIcon } from '../featured-icon';
var CloseButton = function (_a) {
    var closeToast = _a.closeToast;
    return (React.createElement("button", { className: 'color-inherit block', onClick: closeToast },
        React.createElement(XClose, { className: 'size-5' })));
};
var iconClassName = "block -mt-2 -mb-3 -mx-2.5";
function Icon(_a) {
    var type = _a.type;
    switch (type) {
        case 'success':
            return React.createElement(FeaturedIcon, { variant: 'outline', size: 'md', color: 'success', icon: CheckCircle, className: iconClassName });
        case "error":
            return React.createElement(FeaturedIcon, { variant: 'outline', size: 'md', color: 'error', className: iconClassName });
        case "warning":
            return React.createElement(FeaturedIcon, { variant: 'outline', size: 'md', color: 'warning', className: iconClassName });
        case "info":
            return React.createElement(FeaturedIcon, { variant: 'outline', size: 'md', color: 'gray', icon: InfoCircle, className: iconClassName });
        case "default":
            return React.createElement(FeaturedIcon, { variant: 'outline', size: 'md', color: 'primary', icon: InfoCircle, className: iconClassName });
        default:
            return React.createElement(React.Fragment, null);
    }
}
export function ToastContainer(props) {
    return React.createElement(RToastContainer, __assign({ hideProgressBar: true, pauseOnFocusLoss: false, autoClose: 5000, closeButton: CloseButton, icon: Icon }, props));
}
